import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../context/AuthContext";
import AffiliationService from "../../services/AffiliationService";
import "./AffiliationCard.css";
import MainInput from "../Elements/MainInput/MainInput";
import MainButton from "../Elements/MainButton/MainButton";
import PayoutRequestModal from "../../components/Affiliation/PayoutRequestModal";
import SecondButton from "../Elements/SecondButton/SecondButton";
import copyIcon from "../../assets/copy-alt.png";
import moneyIcon from "../../assets/icons/money.png";
import walletIcon from "../../assets/icons/wallet.png";

const AffiliationCard = () => {
  const [copiedField, setCopiedField] = useState(null);
  const [payoutModalOpen, setPayoutModalOpen] = useState(false);
  const [payoutLoading, setPayoutLoading] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [wallet, setWallet] = useState(null);
  const [affiliateData, setAffiliateData] = useState(null);
  const [statsData, setStatsData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [affiliationLink, setAffiliationLink] = useState("https://telviora.com/register?a=CODE");

  const walletId = affiliateData?.wallet_id;
  const totalProvision = statsData?.total_provision;

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        setError(null);

        // affilacja
        const affiliateRes = await AffiliationService.getAffiliation();
        setAffiliateData(affiliateRes);
        setAffiliationLink("https://telviora.com/register?a=" + affiliateRes.code);

        if (affiliateRes?.wallet_id) {
          const statsRes = await AffiliationService.getAffiliationStats();
          setStatsData(statsRes.total);
        } else {
          setStatsData(null);
        }

        const walletRes = await AffiliationService.getWalletByUser();
        setWallet(walletRes);
      } catch (err) {
        if (err.response?.status === 404) {
          setAffiliateData(null);
          setAffiliationLink("https://telviora.com/register?a=CODE");
          setStatsData(null);
        } else {
          setError("Failed to load data");
        }
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const copyToClipboard = async (text, fieldName) => {
    try {
      await navigator.clipboard.writeText(text);
      setCopiedField(fieldName);
      setTimeout(() => setCopiedField(null), 2000);
    } catch (err) {
      console.error("Failed to copy:", err);
    }
  };

  const handleDeleteAffiliation = async () => {
    if (deleteLoading) return;

    const confirmed = window.confirm(
      "Deactivate affiliate account?\n\n" +
        "This will stop earning commissions and delete your referral link.\n" +
        "Cannot be undone.",
    );

    if (!confirmed) return;

    try {
      setDeleteLoading(true);
      await AffiliationService.deleteAffiliation();
      window.location.reload();
    } catch (err) {
      alert("Failed to deactivate: " + err.message);
    } finally {
      setDeleteLoading(false);
    }
  };

  if (!loading && !affiliateData?.wallet_id) {
    return (
      <section className="summary-card affiliation-empty">
        <div className="empty-affiliation-state">
          <p>Want to earn commissions? Click "Create Affiliation" button above to join our program.</p>
        </div>
      </section>
    );
  }

  if (loading) {
    return <div className="loading-placeholder">Loading...</div>;
  }

  if (error) {
    return <div className="error-placeholder">{error}</div>;
  }

  return (
    <div className="affiliation-created-section">
      {/* Left: PayGo / One-off */}
      <div className="affiliation-left-section">
        <div className="esim-id-section">
          <div className="affiliation-link-section">
            <label className="affiliation-link-header">Affiliation Link</label>
            <p className="affiliation-link-description">
              Share link → Users register → Earn on all their eSIM purchases.
            </p>
          </div>

          <div className="input-with-copy">
            <MainInput readOnly value={affiliationLink} placeholder="https://telviora.com/sign-in?affiliate=AFFIL_ID" />
            <button
              className={`copy-btn ${copiedField === "iccid" ? "copied" : ""}`}
              onClick={() => copyToClipboard(affiliationLink, "iccid")}
              title="Copy to clipboard"
            >
              <img src={copyIcon} alt="Copy" />
            </button>
          </div>
        </div>
        <div className="payments-row">
          {/* Money Item 1 - PayGo */}
          {/* <div className="money-item">
            <div className="money-header">
              <img src={moneyIcon} alt="" className="money-icon" />
              <span className="money-label">PayGo</span>
            </div>
            <span className="money-value">
              {affiliateData?.pay_go_mrg?.toFixed(2)} {walletCurrency}
            </span>
          </div> */}

          <div className="money-item">
            <div className="money-header">
              <img src={walletIcon} alt="" className="money-icon" />
              <span className="money-label">Balance</span>
            </div>
            <span className="money-value">
              {wallet?.balance?.toFixed(2)} {wallet?.currency}
            </span>
          </div>

          {/* Money Item 2 - One-off */}
          <div className="money-item">
            <div className="money-header">
              <img src={moneyIcon} alt="" className="money-icon" />
              <span className="money-label">One-off</span>
            </div>
            <span className="money-value">
              {affiliateData?.one_off_mrg != null ? affiliateData.one_off_mrg : "0"} %
            </span>
          </div>

          {/* Kolumna przycisków */}
          {/* Kolumna przycisków */}
          <div className="actions-column">
            <MainButton
              className="payout-btn"
              onClick={() => setPayoutModalOpen(true)}
              disabled={payoutLoading || !walletId}
              // disabled={payoutLoading || !walletId || !totalProvision}
            >
              Payout
            </MainButton>

            <SecondButton className="deactivate-btn" onClick={handleDeleteAffiliation} disabled={deleteLoading}>
              {deleteLoading ? "Deleting..." : "Deactivate"}
            </SecondButton>
          </div>
        </div>
      </div>

      {/* Right: Stats */}
      <div className="stats-section">
        <div className="stat-item">
          <span className="stat-label">Link Entries</span>
          <span className="stat-value">{statsData?.total_link_entries || 0}</span>
        </div>
        <div className="stat-item">
          <span className="stat-label">Users Registered</span>
          <span className="stat-value">{statsData?.total_users_registered || 0}</span>
        </div>
        <div className="stat-item">
          <span className="stat-label">Total Users Spent</span>
          <span className="stat-value">
            {statsData?.total_amount?.toFixed(2) || 0} {wallet?.currency || "EUR"}
          </span>
        </div>
        <div className="stat-item">
          <span className="stat-label">Your Total Provision</span>
          <span className="stat-value">
            {statsData?.total_provision?.toFixed(2) || 0} {wallet?.currency || "EUR"}
          </span>
        </div>
      </div>
      <PayoutRequestModal
        isOpen={payoutModalOpen}
        onClose={() => setPayoutModalOpen(false)}
        walletId={walletId}
        maxAmount={totalProvision}
        onSuccess={() => {}}
      />
    </div>
  );
};

export default AffiliationCard;
